import { checkoutService } from './service'
import { createFetchHook } from '../../acato-utils'

export const checkoutServiceHooks = createFetchHook(checkoutService)
